<template>
  <div class="receipt-list">
    <!-- 搜索 -->
    <div class="search">
      <el-form
        :model="exportForm"
        ref="exportForm"
        class="demo-ruleForm"
      >
        <div class="form-row">
          <el-form-item prop="warehouseId" label="仓库名称：">
            <el-select
              v-model="exportForm.warehouseId"
              placeholder="请选择仓库"
              @change="changeWarehouse"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
            <el-form-item prop="projectName" label="项目名称：">
              <el-select
                v-model="exportForm.projectName"
                placeholder="请选择项目"
                @change="changeProject"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          <el-form-item prop="date" label="日期：">
            <el-date-picker
              v-model="exportForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-row">
          <el-form-item prop="checked" class="check">
            <el-checkbox v-model="exportForm.checked"
              >展示作废记录</el-checkbox
            >
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="reset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div class="title-container">
      <p class="table-title">增值服务信息</p>
      <div class="import-export">
        <div class="upload-btn" @click="openUpload">
          <span class="upload-btn-img"></span>
          <span>导入</span>
        </div>
        <div class="upload-return" @click="exportLoginForm('exportForm')">
          <span class="upload-return-img"></span>
          <span>导出</span>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="table">
      <el-table 
        :data="tableData" 
        style="width: 100%" 
        :row-class-name="tableRowClassName"
        :header-cell-class-name="headerCellClassName"
      >
        <el-table-column
          v-for="(item, index) in tableTitle"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.width"
          show-overflow-tooltip
          :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
        >
        </el-table-column>
        <el-table-column label="操作" min-width="80">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status !== 1" class="btn-text" type="text" @click="nullify(scope.row.id)"
              >作废</el-button
            >
            <el-button v-else class="btn-text nullify" type="text" disabled
              >作废</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>

    
    <!-- 导入 -->
    <el-drawer
      title="增值服务导入"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <el-form class="entry-form" ref="entryForm" :model="entryForm" :rules="rules">
        <div class="tips">
          <img class="sign-blue" src="~assets/images/sigh/sigh-blue.png">
          <span class="tips-content">可批量导入增值服务信息</span>
          <span class="tips-text">（功能介绍）</span>
        </div>
        <el-form-item label="仓库名称" prop="warehouseId">
          <el-select 
            class="white"
            clearable
            v-model="entryForm.warehouseId"
            placeholder="请选择仓库名称"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker
            v-model="entryForm.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="下载导入模板">
          <div class="download-tmp" @click="downTmp">
            增值服务导入模板.xlsx
            <img class="upload-bottom" src="~assets/images/upload/upload-bottom.png">
          </div>
        </el-form-item>
        <el-form-item label="增值服务导入">
          <el-input v-if="!uploadFileName" v-model="uploadFileName" placeholder="请上传文件" disabled>
            <template slot="suffix">
              <el-upload
                v-loading.fullscreen.lock="loading"
                element-loading-text="文件上传中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                class="upload"
                ref="upload"
                action="#"
                :show-file-list="false"
                :auto-upload="true"
                :before-upload="uploadWarehouseLocationExcel"
              >
                <img class="upload-img" src="~assets/images/home/upload.png">
              </el-upload>
            </template>
          </el-input>
          <div v-else class="show-name">
            <span>{{ uploadFileName }}</span>
            <img @click="clearUploadFileName" src="~assets/images/close.png">
          </div>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="confirm('entryForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import ChargeRegister from "models/charge-register";
import warehouseMixins from "@/common/mixins/warehouse.js"
import projectMixins from "@/common/mixins/project.js"
import PaginationTpl from "components/base/PaginationTpl";
import { numsToRMBSymbolAndMillimeter, downLoadFileByBlob, downLoadFile } from "common/js/util";
export default {
  mixins: [warehouseMixins, projectMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      exportForm: {
        warehouseId: '',
        date: "",
        customerId: '',
        projectName: '',
         // 1: 大宗出库; 2:退货服务; 3: 卸货服务; 4:增值服务
        serviceContent: 4,
        // 是否展示作废记录
        checked: false,
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitle: [
        {label: '仓库名称', prop: 'warehouseName', width: '120', alignment:'left'},
        {label: '项目名称', prop: 'projectName', width: '140', alignment:'left'},
        {label: '日期', prop: 'creatTime', width: '100', alignment:'left'},
        {label: '商品条码', prop: 'goodsCode', width: '200', alignment:'left'},
        {label: '商品名称', prop: 'goodsName', width: '150', alignment:'left'},
        {label: '货主单号', prop: 'customerOrderCode', width: '120', alignment:'left'},
        {label: '数量', prop: 'nums', width: '140', alignment:'right'},
        {label: '服务名称', prop: 'serviecName', width: '140', alignment:'left'},
        {label: '单价', prop: 'unitPrice', width: '140', alignment:'right'},
        {label: '金额', prop: 'amount', width: '140', alignment:'right'},
        {label: '备注', prop: 'remarks', width: '120', alignment:'left'},
      ],
      drawer: false,
      entryForm: {
        warehouseId: '',
        date: ''
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库名称', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择月份', trigger: 'change' }
        ]
      },
      loading: false,
      uploadFileName: '',
      /* 订单导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,
    }
  },

  created() {
    this.initWarehouse()
    this.initLabelList()
  },

  methods: {
    /**
     * @desc 初始化增值服务信息列表
     */
    initLabelList() {
      let warehouseId	 = this.exportForm.warehouseId
      let beginDate	 = this.exportForm.date[0]
      let endDate	 = this.exportForm.date[1]
      let customerId	 = this.exportForm.customerId
      let projectId	 = this.exportForm.projectName
      let isCancel	 = this.exportForm.checked?1:0
      let currentPage	 = this.currentPage
      let data = {
        warehouseId,
        beginDate,
        endDate,
        customerId,
        projectId,
        isCancel,
        currentPage,
      }
      ChargeRegister.getChargeRecordLabelList(data).then((res) => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum
          res.result.items.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.warehouseName = value.warehouseName;
            obj.creatTime = value.billDate;
            obj.remarks = value.remarks;
            obj.customersName = value.customerName;
            obj.projectName = value.projectName;
            obj.status = value.isCancel;
            obj.nums = value.checkNum;
            obj.serviecName = value.extraServiceName;
            obj.unitPrice = numsToRMBSymbolAndMillimeter(value.unitPrice);
            obj.amount = numsToRMBSymbolAndMillimeter(value.checkPrice);
            obj.goodsCode = value.goodsCode;
            obj.goodsName = value.goodsName;
            obj.customerOrderCode = value.customerOrderCode;
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    
    searchData() {
      this.currentPage = 1;
      this.initLabelList();
    },
    
    /**
     * @desc 重置搜索内容
    */
    reset() {
      this.exportForm.date = ""
      this.exportForm.warehouseId = ""
      this.exportForm.customerId = ""
      this.exportForm.projectName = ""
      this.exportForm.checked = false
    },

    /** 
     * @desc 作废
    */
    nullify(id) {
      this.$confirm("作废后，该增值服务单将不可再次操作，请确认", "作废", {
        confirmButtonText: "作废",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-red",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let data = {
          id
        }
        ChargeRegister.postNullify(data, this.exportForm.serviceContent).then(res => {
          if (res.success) {
            this.initLabelList();
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
      });
    },

    changeWarehouse() {
      let warehouseId = this.exportForm.warehouseId;
      this.initProjectListByWarehouse(warehouseId);
    },

    changeProject() {
      let obj = this.projectList.find(item => { return item.id == this.exportForm.projectName })
      this.exportForm.customerId = obj.customerId
    },
    
    /**
     * @desc 导出
     */
    exportLoginForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId	 = this.exportForm.warehouseId
          let beginDate	 = this.exportForm.date[0]
          let endDate	 = this.exportForm.date[1]
          let customerId	 = this.exportForm.customerId
          let projectId	 = this.exportForm.projectName
          let isCancel	 = this.exportForm.checked?1:0
          let currentPage	 = this.currentPage
          let data = {
            warehouseId,
            beginDate,
            endDate,
            customerId,
            projectId,
            isCancel,
            currentPage,
          }
          ChargeRegister.getExport(data, this.exportForm.serviceContent).then((res) => {
            downLoadFileByBlob(res)
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    /** 
     * @desc 为 Table 中的某一行添加 class
    */
    tableRowClassName({row}) {
      if (row.status !== 1) {
        return '';
      }
      return 'active';
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if (columnIndex == 6 || columnIndex == 8 || columnIndex == 9) {
        return 'right-align'
      }
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initLabelList();
    },

    /** 
     * @desc 开启导入
    */
    openUpload() {
      this.drawer = true
    },
    
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.entryForm.warehouseId
          let billDate = this.entryForm.date

          if (this.isUpload) {
            return this.$message.error("请导入文件");
          }
          let formData = this.formData
          if (formData.get('warehouseId')) {
            formData.delete('warehouseId')
          }
          if (formData.get('billDate')) {
            formData.delete('billDate')
          }
          formData.append("warehouseId", warehouseId);
          formData.append("billDate", billDate);

          ChargeRegister
            .postUploadChargeRecordLabel(formData)
            .then(res => {
              if (res.success) {
                this.$message.success("导入成功");
                this.initLabelList()
                this.handleCloseDrawer()
              } else {
                this.$confirm(res.message, "提示", {
                  showCancelButton: false,
                  confirmButtonText: "确定",
                  type: "warning"
                }).then(() => { });
              }
            })
            .catch(res => {
              console.log(res);
              this.$message.error("导入失败");
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    handleCloseDrawer() {
      this.entryForm.warehouseId = ''
      this.entryForm.date = ''
      this.removeUploadOrder()
      this.drawer = false
    },

    removeUploadOrder() {
      this.formData = null
      this.isUpload = true
      this.uploadFileName = ''
    },

    downTmp() {
      let fileName = '增值服务导入模板'
      let url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E5%A2%9E%E5%80%BC%E6%9C%8D%E5%8A%A1%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
      downLoadFile(fileName, url)
    },

    //导入Excel表格
    uploadWarehouseLocationExcel(file) {
      this.loading = true
      var formData = new FormData();
      formData.append("file", file);
      this.formData = formData
      this.uploadFileName = file.name
      this.isUpload = false
      if (file) {
        this.loading = false
      }
      return false;
    },


    /**
     * @desc 删除上传文件
     */
    clearUploadFileName() {
      this.uploadFileName = ''
      let formData = this.formData
      this.isUpload = true
      if (formData.get('file')) {
        formData.delete('file')
      }
    },
  }
}
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/receipt-list.scss";
</style>